var _title, _desc, _use, _use2, _use3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTfwLogoSymbol = function SvgTfwLogoSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 83 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "TFW-Logo-Symbol_RGB_2017_RZ")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(-966 17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TFW-Logo-Symbol_RGB_2017_RZ"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TFW Logo Zweizeilig RGB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "red",
    style: {
      mixBlendMode: "multiply"
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(980.317 11.5802)",
    fill: "#E45F75"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "yellow",
    style: {
      mixBlendMode: "multiply"
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(994.479 -17)",
    fill: "#FDC400"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "blue",
    style: {
      mixBlendMode: "multiply"
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(966 -17)",
    fill: "#64B6E7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape 1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path3_fill",
    transform: "translate(994.62 6.04567)",
    fill: "#FFFFFF"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 27.2606 54.4198C 42.3162 54.4198 54.5211 42.2375 54.5211 27.2099C 54.5211 12.1823 42.3162 0 27.2606 0C 12.205 0 0 12.1823 0 27.2099C 0 42.2375 12.205 54.4198 27.2606 54.4198Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M 27.2606 54.4198C 42.3162 54.4198 54.5211 42.2375 54.5211 27.2099C 54.5211 12.1823 42.3162 0 27.2606 0C 12.205 0 0 12.1823 0 27.2099C 0 42.2375 12.205 54.4198 27.2606 54.4198Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M 27.2606 54.4198C 42.3162 54.4198 54.5211 42.2375 54.5211 27.2099C 54.5211 12.1823 42.3162 0 27.2606 0C 12.205 0 0 12.1823 0 27.2099C 0 42.2375 12.205 54.4198 27.2606 54.4198Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    d: "M 12.8978 27.3582C 19.5064 23.3304 24.2311 16.5798 25.5088 8.70812C 25.6158 8.0556 25.693 7.40309 25.7525 6.73277C 25.7525 6.6438 25.7525 6.53702 25.7525 6.43025C 25.7525 2.88887 22.8107 -7.24116e-07 19.2033 -7.24116e-07C 16.1902 -7.24116e-07 13.6466 2.005 12.8859 4.72777C 12.1252 2.005 9.58155 -7.24116e-07 6.56845 -7.24116e-07C 2.96105 -7.24116e-07 0.0192589 2.87107 0.0192589 6.43025C 0.0192589 6.50736 0.0192589 6.59634 0.0192589 6.67346C 0.037088 6.76243 0.037088 6.85735 0.048974 6.93446C 0.031145 6.84548 0.031145 6.75057 0.0192589 6.67346C -0.0401711 5.89637 0.0370883 7.28445 0.262923 8.69626C 1.56444 16.6154 6.30102 23.3304 12.8978 27.3582C 12.8978 27.376 12.8978 27.376 12.8978 27.3582Z"
  }))));
};
export default SvgTfwLogoSymbol;